import { render } from "./PSelectLegado.vue?vue&type=template&id=8fc282f8&lang=pug"
import script from "./PSelectLegado.vue?vue&type=script&lang=js"
export * from "./PSelectLegado.vue?vue&type=script&lang=js"

import "./PSelectLegado.vue?vue&type=style&index=0&id=8fc282f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/selectors/PSelectLegado.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fc282f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fc282f8', __exports__)) {
    api.reload('8fc282f8', __exports__)
  }
  
  module.hot.accept("./PSelectLegado.vue?vue&type=template&id=8fc282f8&lang=pug", () => {
    api.rerender('8fc282f8', render)
  })

}


export default __exports__